import * as _ from 'lodash';
import * as moment from 'moment';
import React, { FormEvent } from 'react'
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Radio, Row } from 'react-bootstrap'
import { IPostTransplantRejection, IRecipientProfilePostTransplantData } from '@nkr/models/index'

interface IProps {
    data: IRecipientProfilePostTransplantData,
    rejectionEpisodeList: IPostTransplantRejection[],
    rejectionEpisodeDetailValid: boolean,
    onChange: (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => void,
    onAddRejectionEpisode: () => void,
    onEditRejectionEpisode: (rejectionId: number) => void,
    onDeleteRejectionEpisode: (rejectionId: number) => void,
    onUnDeleteRejectionEpisode: (rejectionId: number) => void
}

const GraftRejectionFailure = (props: IProps) => {
    if (props.data == null || props.data == undefined) {
        return <></>;
    }

    const isValidString = (val: string) => typeof val === 'string' && val.trim().length > 0;

    const showDescriptionOfEpisodes = props.data.donorTyping == null || !isValidString(props.data.histogeneticsRawTypingFile) || !props.data.doesGraftFailureQuestions;

    return (
        <Form horizontal>
            <FormGroup>
                <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                    Post-transplant rejection episode(s)?
                </Col>
                <Col xs={12} sm={12} lg={6}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ minHeight: 34, marginRight: 10 }}>
                            <Radio inline id='rejectionEpisodesYes' name='rejectionEpisodes' value={1} checked={props.data.rejectionEpisodes == 1} onChange={props.onChange}>Yes</Radio>
                            <Radio inline id='rejectionEpisodesNo' name='rejectionEpisodes' value={0} checked={props.data.rejectionEpisodes == 0} onChange={props.onChange}>No</Radio>
                            <Radio inline id='rejectionEpisodesUnknown' name='rejectionEpisodes' value={-1} checked={props.data.rejectionEpisodes == -1} onChange={props.onChange}>Unknown</Radio>
                        </div>
                        {!showDescriptionOfEpisodes && props.data.rejectionEpisodes === 1 && (
                            <Button bsStyle='primary' bsSize='sm' onClick={props.onAddRejectionEpisode}>
                                Add Rejection Episode
                            </Button>
                        )}
                    </div>
                </Col>
            </FormGroup>

            {showDescriptionOfEpisodes && props.data.rejectionEpisodes === 1 && (
                <FormGroup validationState={props.rejectionEpisodeDetailValid == false ? 'error' : null}>
                    <Col xs={12} sm={12} lg={6} className='text-left'>
                        <ControlLabel>Description of rejection episode(s)?</ControlLabel>
                    </Col>
                    <Col xs={12} sm={12} lg={6}>
                        <FormControl
                            componentClass='textarea'
                            style={{ resize: 'none' }}
                            name='rejectionEpisodeDetail'
                            value={props.data.rejectionEpisodeDetail}
                            onChange={props.onChange}
                        />
                    </Col>
                </FormGroup>
            )}

            {!showDescriptionOfEpisodes && (props.data.rejectionEpisodes === 1 || props.rejectionEpisodeList.length > 0) && (
                <FormGroup>
                    <Col xs={6} lg={12}>
                        {props?.rejectionEpisodeList.map(x =>
                            <Row style={{ margin: '1px', marginTop: '10px' }}>
                                <span>
                                    <Alert bsSize='sm' bsStyle='warning' style={{ display: 'inline-block', width: '50%', paddingTop: 4.5, paddingBottom: 4.5 }}>
                                        <strong> {x.isDraft && <>(DRAFT)</>} Rejection Episode {x.dateOfRejection && moment(x.dateOfRejection).format('MM/DD/YYYY')} </strong>
                                    </Alert>
                                </span>
                                <span>
                                    <Button style={{ marginLeft: 10 }} bsSize='sm' onClick={() => props.onEditRejectionEpisode(x.id)}>Edit</Button>
                                    {x.isDeleted ?
                                        <Button style={{ marginLeft: 5 }} bsSize='sm' onClick={() => props.onUnDeleteRejectionEpisode(x.id)}>Restore</Button>
                                        :
                                        <Button bsStyle='danger' bsSize='sm' style={{ marginLeft: 5 }} onClick={() => props.onDeleteRejectionEpisode(x.id)}>Delete</Button>
                                    }
                                </span>
                            </Row>
                        )}
                    </Col>
                </FormGroup>
            )}
        </Form>
    )
}

export default GraftRejectionFailure